import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';

// material-ui
import { styled } from '@mui/material/styles';
import { Box, InputAdornment, OutlinedInput} from '@mui/material';
import { shouldForwardProp } from '@mui/system';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


interface Props {
    placeHolder: string;
    getSearchResults: any;
    fontSize: number;
    searchInput: string;
}

const OutlineInputStyle = styled(OutlinedInput, { shouldForwardProp })(({ theme }) => ({
    width: 180,
    height:37,
    marginRight: 5,
    marginLeft: 7,
    paddingLeft: 10,
    paddingRight: 5,
    '& input': {
        background: 'transparent !important',
        paddingLeft: '4px !important',
    }
}));

// ==============================|| SEARCH INPUT ||============================== //

const SearchSection = (props: Props) => {

    const [searchPhrase, setSearchPhrase] = useState(props.searchInput);

    function updateSearchPhrase(event: any) {
        setSearchPhrase(event.target.value);
        setTimeout(() => {
            props.getSearchResults(event.target.value);
        }, 1500)
    }

    return (
        <>
            <Box sx={{ display: { xs: 'none', md: 'block' } }}>
                <OutlineInputStyle
                    id="input-search-header"
                    value={searchPhrase}
                    onChange={updateSearchPhrase}
                    placeholder={props.placeHolder}
                    startAdornment={
                        <InputAdornment position="start">
                            <FontAwesomeIcon icon={["fas", "search"]} />
                        </InputAdornment>
                    }
                    aria-describedby="search-helper-text"
                    inputProps={{ 'aria-label': 'search' }}
                    sx={{ fontSize: props.fontSize }}
                />
            </Box>
        </>
    );
};

export default React.memo(SearchSection);